const removeAllFilters = (elementsClass) => {
  [...document.querySelectorAll(`.${elementsClass}`)].forEach((el) => {
    el.classList.remove("filtered");
  });
};

const extractTextFromButton = (btn) => {
  const html = btn.innerHTML.trim();

  return html === 'See more' ? 'more' : 'less';
};

const changeBtnHtml = (btn, moreOrLess) => {
  const opposites = {more: 'less', less: 'more'};

  btn.innerHTML = `See ${opposites[moreOrLess]}`;
};

const showAllUnfilteredCategoryItems = (filterElementsClass) => {
  document.querySelectorAll(`.${filterElementsClass}`).forEach(el => el.classList.remove('hide'));
};

const renderSeeMoreButton = (btnClass, categoryElementsClass, seeMoreSliceOptions) => {
  const seeMoreButton = document.querySelector(`.${btnClass}`);
  seeMoreButton.classList.remove('hide');
  if (hideExcessEntries(categoryElementsClass, seeMoreSliceOptions)) {
    seeMoreButton.innerHTML = "See more";
    seeMoreButton.classList.remove('open');
  } else {
    seeMoreButton.classList.add('hide');
  }
};

const hideExcessEntries = (categoryElementsClass, sliceOptions) => {
  const allCategoryItems = document.querySelectorAll(`.${categoryElementsClass}:not(.filtered)`);
  const mobile = window.matchMedia("(max-width: 768px)").matches;
  const sliceAmount = mobile ? sliceOptions.mobile : sliceOptions.desktop;
  showAllUnfilteredCategoryItems(categoryElementsClass);

  if (allCategoryItems.length <= sliceAmount) { return false; }

  [...allCategoryItems].slice(sliceAmount).forEach((el) => {
    el.classList.add('hide');
  });

  return true;
};

const expandEventsSidenav = (moreOrLess) => {
  const sidenav = document.querySelector('.events-sidenav-column');
  const eventsHeight = document.querySelector('.events-page').offsetHeight;
  if (moreOrLess === 'less') {
    window.scrollTo(0, 230);
  }

  if (window.matchMedia("(min-width: 62em)").matches) {
    sidenav.style.maxHeight = `${Math.min(500, eventsHeight)}px`;
  }
};

const attachSeeMoreButtonHandlers = (buttonClass, filterElementsClass, seeMoreSliceOptions) => {
  if (buttonClass) {
    const seeMoreButton = document.querySelector(`.${buttonClass}`);

    if(!hideExcessEntries(filterElementsClass, seeMoreSliceOptions)) {
      seeMoreButton.classList.add('hide');
    };

    seeMoreButton.addEventListener('click', () => {
      const moreOrLess = extractTextFromButton(seeMoreButton);

      if (moreOrLess === 'more') {
        showAllUnfilteredCategoryItems(filterElementsClass);
        seeMoreButton.classList.add('open');
      }

      if (moreOrLess === 'less') {
        hideExcessEntries(filterElementsClass, seeMoreSliceOptions);
        seeMoreButton.classList.remove('open');
        window.scrollTo(0, 400);
      }

      changeBtnHtml(seeMoreButton, moreOrLess);

      if (filterElementsClass === 'events-event') {
        expandEventsSidenav(moreOrLess);
      }
    });
  }
};

export {
  removeAllFilters,
  extractTextFromButton,
  changeBtnHtml,
  showAllUnfilteredCategoryItems,
  renderSeeMoreButton,
  hideExcessEntries,
  attachSeeMoreButtonHandlers,
}



// WEBPACK FOOTER //
// ./src/pages/helpers/sidenavHelpers.js